module.exports = __webpack_public_path__ + "static/media/seven.595e86f5.ogg";